import { TransferBaseModel } from '../transfer-base.model';
export enum PromotionType {
    COMPLIANCE = 'COMP',
    GENERAL = 'GEN',
    NOTIFICATION = 'NOTI',
    PAYMENTS = 'PAY',
    WHATS_HOT = 'WH'
}

export const Languages = [
    'en-US',
    'zh-CN',
    'zh-TW',
    'ko-KR',
    'ko-KR',
    'vi-VN',
    'id-ID',
    'es-ES',
    'it-IT',
    'fr-FR',
    'de-DE',
    'pt-PT',
    'pt-BR',
    'ja-JP'
];

interface PromotionStrict extends TransferBaseModel {
    tenants_linked: { id: string }[];
    name: string;
    translation_action_key: string;
    translation_body_key: string;
    translation_header_key: string;
    promotion_type: PromotionType;
    action_type: string;
    action_data: string;
    from_date: Date;
    to_date: Date;
    priority: number;
    is_always_visible: boolean;
    is_action_visible: boolean;
    is_icon_visible: boolean;
    enabled: boolean;
    ib_accounts: boolean;
    ib_client_accounts: boolean;
    direct_accounts: boolean;
    china_only: boolean;
    exclusion_emails: string[];
    inclusion_emails: string[];
    created_date: Date;
    languages: string[];
    image: string;
    countries: string[];
}

export type Promotion = Partial<PromotionStrict>;

export interface PromotionFilterBody {
    countries?: string[];
    languages?: string[];
    is_admin_page?: boolean;
}
